import AppDispatcher from '../dispatcher/AppDispatcher'
import assign from 'object-assign'
import { EventEmitter } from 'events'
import * as DonationConstants from '../utility/constants'

const CHANGE_EVENT = 'change';

let _alldata = {}; // collection of donation data

/**
 * @param {string} text The content donation
 */
function create(field, value) {

	_alldata[field] = value;
}

var DonationStore = assign({}, EventEmitter.prototype, {
	emitChange: function() {
		this.emit(CHANGE_EVENT);
	},

	getAllData: function() {
		return _alldata;
	},

	getDonationAmount: function() {
		return _alldata.amount;
	},

	getDonationSymbol: function() {
		return _alldata.symbol;
	},

	getDonationCode: function() {
		return _alldata.code;
	},

	getFormatedAmount: function() {
		return _alldata.formatedAmount;
	},

	getDonationNote: function() {
		return _alldata.note;
	},

	getDonationRecurring: function() {
		return _alldata.recurring;
	},

	getRecurringModalStatus: function() {
		return _alldata.recurringModalStatus;
	},

	getConfirmation: function() {
		return _alldata.confirmation;
	},

	getPostBackData: function() {
		return _alldata.postBackData;
	},

	getCurrentPage: function() {
		return _alldata.currentPage;
	},

	getServerErros: function() {
		return _alldata.serverErrors;
	},

	getPaymentError: function() {
		return _alldata.paymentError;
	},

	getSignUpError: function() {
		return _alldata.signUpError;
	},

	getFundingOptions: function() {
		return _alldata.fundingOptions;
	},

	getEmail: function() {
		return _alldata.email;
	},

	getBillingAddress: function() {
		return _alldata.billingAddress;
	},

	getUserCountry: function() {
		return _alldata.country;
	},

	getDonationAmountType: function() {
		return _alldata.donationAmountType;
	},

	getGiftaidItFlagStatus: function() {
		return _alldata.giftAidItFlag;
	},

	getShareAddress: function() {
		return _alldata.shareAddress;
	},

	getAddCardError: function() {
		return _alldata.addCardError;
	},

	getGiftAidItExtraAmount: function() {
		return DonationConstants.DONATE_GIFTAID_IT_EXTRA_AMOUNT;
	},

	dispatcherIndex: AppDispatcher.register(function(payload) {
		var action = payload.action;
		var amount, recurring, recurringModalStatus, note, symbol, code, formatedAmount, country, confirmation, postBackData, currentPage, serverErrors, paymentError, signUpError, fundingOptions, email, billingAddress, giftAidItFlag;

		switch (action.actionType) {

			case DonationConstants.CHANGE_AMOUNT:
				amount = action.item.amount.trim();
				if (amount !== '') {
					create('amount', amount);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_SYMBOL:
				symbol = action.item.symbol.trim();
				if (symbol !== '') {
					create('symbol', symbol);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_CODE:
				code = action.item.code.trim();
				if (code !== '') {
					create('code', code);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_FORMATED_AMOUNT:
				formatedAmount = action.item.formatedAmount;
				if (formatedAmount !== '') {
					create('formatedAmount', formatedAmount);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_RECURRING:
				recurring = action.item.recurring.trim();
				if (recurring !== '') {
					create('recurring', recurring);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.RP_MODAL_CLOSED:
				recurringModalStatus = action.item.recurringModalStatus.trim();
				if (recurringModalStatus !== '') {
					create('recurringModalStatus', recurringModalStatus);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_NOTE:
				note = action.item.note.trim();
				if (note !== '') {
					create('note', note);
					DonationStore.emitChange();
				} else {
					create('note', '');
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.CHANGE_COUNTRY:
				country = action.item.country.trim();
				if (country !== '') {
					create('country', country);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_CONFIRMATION:
				confirmation = action.item.confirmation;
				if (confirmation !== '') {
					create('confirmation', confirmation);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.POST_BACK_DATA:
				postBackData = action.item.postBackData;
				if (postBackData !== '') {
					create('postBackData', postBackData);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_CURRENT_PAGE:
				currentPage = action.item.currentPage;
				if (currentPage !== '') {
					create('currentPage', currentPage);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_SERVER_ERRORS:
				serverErrors = action.item.serverErrors;
				if (serverErrors !== '') {
					create('serverErrors', serverErrors);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.PAYMENT_ERROR:
				paymentError = action.item.paymentError;
				if (paymentError !== '') {
					create('paymentError', paymentError);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_SIGN_UP_ERROR:
				signUpError = action.item.signUpError;
				if (signUpError !== '') {
					create('signUpError', signUpError);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.FUNDING_OPTIONS:
				fundingOptions = action.item.fundingOptions;
				if (fundingOptions !== '') {
					create('fundingOptions', fundingOptions);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.EMAIL:
				email = action.item.email;
				if (email !== '') {
					create('email', email);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.BILLING_ADDRESS:
				billingAddress = action.item.billingAddress;
				if (billingAddress !== '') {
					create('billingAddress', billingAddress);
					DonationStore.emitChange();
				}
				break;

			case DonationConstants.UPDATE_DONATION_AMOUNT_TYPE:
				create('donationAmountType', action.item);
				DonationStore.emitChange();
				break;

			case DonationConstants.GIFT_AID_IT:
				giftAidItFlag = action.item.giftAidItFlag;
				create('giftAidItFlag', giftAidItFlag);
				DonationStore.emitChange();
				break;

			case DonationConstants.CHANGE_SHARE_ADDRESS:
				create('shareAddress', action.item);
				DonationStore.emitChange();
				break;

			case DonationConstants.ADD_CARD_ERROR:
				create('addCardError', action.item);
				DonationStore.emitChange();
				break;

			default:
				break;
		}

		return true; // No errors. Needed by promise in Dispatcher.
	})
});

AppDispatcher.register((payload) => {
	return true;
});

module.exports = DonationStore;



// WEBPACK FOOTER //
// ./stores/AppStore.js